import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../environments/environment';

@Injectable()
export class DeviceService {
  href: string = environment.heardata_api;

  constructor(private http: HttpClient) {
    console.log('constructing device');
  }

  AddDevice(imei: string): Observable<any> {
    const requestUrl = `${this.href}/api/v2/admin/device`;
    return this.http.post<any>(requestUrl, { imei: imei });
  }

  SearchDevice(imei: string): Observable<any> {
    const requestUrl = `${this.href}/api/v2/admin/device?imei=${imei}`;
    return this.http.get<any>(requestUrl);
  }

  AddDevice2(device: {imei: string, model?: string}): Observable<any> {
    const requestUrl = `${environment.hardware_api}/v1/device`;
    const headers = new HttpHeaders({
      Authorization: 'token ' + environment.hardware_token,
    });

    return this.http.post<any>(requestUrl, device, { headers: headers });
  }
}



// WEBPACK FOOTER //
// ./src/app/device.service.ts